var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "w-full mobile:p-4 tablet:p-6",
      attrs: { "data-test": "tab-chapters" }
    },
    [
      _c(
        "tab-title",
        { attrs: { tab: "chapters" }, on: { close: _vm.closeTab } },
        [_vm._v(_vm._s(_vm.$t("CHAPTERS.TITLE")))]
      ),
      _c(
        "ol",
        {
          staticClass: "sr-only",
          attrs: { "aria-label": _vm.$t(_vm.a11y.key, _vm.a11y.attr) }
        },
        _vm._l(_vm.chapters, function(chapter, index) {
          return _c("a11y", {
            key: "a11y-" + index,
            attrs: { chapter: chapter, index: index }
          })
        }),
        1
      ),
      _vm._l(_vm.chapters, function(chapter, index) {
        return _c("entry", {
          key: "chapter-" + index,
          attrs: { "aria-hidden": "true", chapter: chapter, index: index }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }